// the above line makes the linter ignore Sys.* errors, Sys DOES exist, it is part of ASP.Net, but logically it does NOT exist 'here'
// requires for external dependencies and other global stuff go here
/* eslint-disable no-unused-vars */

import helper from './util/helper';
// import Lazysizes from 'lazysizes';

import Swiper from '../Scripts/modules/swiper/swiper.module';
import collapse from '../Scripts/modules/collapse/collapse.module';
import eventListeners from '../Scripts/modules/eventlisteners/eventlisteners.module';
import floatingLabels from '../Scripts/modules/forms/forms.module';
import gallery from '../Scripts/modules/gallery/gallery.module';
import scrollTrigger from '../Scripts/modules/gsap/scrolltrigger.module';
import goToPage from '../Scripts/modules/paging/paging.module';
import gridLayout from '../Scripts/modules/grid/grid.module';
import linkConverter from '../Scripts/modules/linkconverter/linkconverter.module';
import nav from '../Scripts/modules/nav/nav.module';
import table from '../Scripts/modules/table/table.module';
import productDetail from '../Scripts/modules/products/productdetail.module';
import productOverview from '../Scripts/modules/products/product-overview.vue';
import productDetailAddToBasket from '../Scripts/modules/products/product-detail-addtobasket.vue';
import basketOverview from '../Scripts/modules/ecommerce/basket-overview.vue';
import basketTopButtons from '../Scripts/modules/ecommerce/basket-top-buttons.vue';

import './util/polyfill';

// import $ from 'jquery';
import Vue from 'Vue';
// import Vuex from 'vuex';

Vue.filter("toCurrency", (value) => {
	if (typeof value !== 'number') {
		return value;
	}
	var formatter = new Intl.NumberFormat('nl-NL', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 2
	});
	return formatter.format(value);
});

// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/index';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/tooltip';
// import 'bootstrap/js/dist/util';

/* eslint-enable no-unused-vars */

// make sure Promise is present
// require('es6-promise/auto');

// Init function, can be used for startup stuff
function init() {
    floatingLabels();
    gridLayout();
    collapse();
    Swiper();
    linkConverter();
    eventListeners();
    table();
    gallery();
    nav();
    scrollTrigger();
    productDetail();

	// settings for the basket (overview)
    var basketSettings = { ...window.basketSettings };
	var productDetails = { ...window.productDetailProperties };
	var authProperties = { ...window.authProperties };

    var ProductOverview = document.getElementById('vue-product-overview');
    if (ProductOverview) {
        new Vue({
            el: '#vue-product-overview',
            render(createElement) {
                return createElement(productOverview,
                    {
                        props: {
                            data: ProductOverview.dataset
                        }
                    }
                );
            }
        });
    }

    var ProductDetailAddToBasket = document.getElementById('vue-product-detail-addtobasket');
    if (ProductDetailAddToBasket) {
        new Vue({
            el: '#vue-product-detail-addtobasket',
            render(createElement) {
                return createElement(productDetailAddToBasket,
                    {
                        props: {
                            productDetails: productDetails
                        }
                    }
                );
            }
        });
    }

    var BasketOverview = document.getElementById('vue-basket-overview');
    if (BasketOverview) {
        new Vue({
            el: '#vue-basket-overview',
            render(createElement) {
                return createElement(basketOverview,
                    {
                        props: {
                            basketSettings: basketSettings
                        }
                    }
                );
            }
        });
    }

    var BasketTopButtons = document.getElementById('vue-basket-topbuttons');
    if (BasketTopButtons) {
        new Vue({
            el: '#vue-basket-topbuttons',
            render(createElement) {
				return createElement(basketTopButtons,
					{
						props: {
							authProperties: authProperties
						}
					}
				);
            }
        });
    }
}

export default {
    init
};
